import { ompApiClient } from "@app/config/axios/clients/ompApiClient";
import type { RequestConfig } from "@app/config/axios/http";

/**
 * Транспортный слой OMP — проверка токена.
 */
export const authApi = {
    /** Проверяет валидность авторизационного токена. */
    checkTokenValidity: async (config?: RequestConfig): Promise<void> => {
        await ompApiClient.postOmega("currentUser.getOmpUser", {}, config);
    },
} as const;
